export default "__VITE_ASSET__mng_NW2C__"